import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
    paper: {
        borderRadius: '30px',
        boxShadow: '0 2px 10px rgba(0, 0, 0, 0.2)',
        padding: theme.spacing(2),
        backgroundColor: '#F5F8F9',
        marginTop: '0%'
    },
    container: {
        display: 'flex',
        alignItems: 'center',
        borderRadius: 15,
        padding: theme.spacing(1),
    },
    headerContainer: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        flexWrap: 'wrap',
        width: '100%',
        marginBottom: '2%'
    },
    title: {
        fontSize: '25px',
        fontWeight: 'bold',
        marginTop: '2.5%',
        marginBottom: '2%',
    },
    iconButton: {
        padding: 10,
    },
    cardsContainer: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'stretch',
        gap: theme.spacing(2),
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
    },
    card: {
        padding: theme.spacing(3),
        marginBottom: theme.spacing(2),
        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
        borderRadius: '10px',
        height: 'auto',
    },
    cardContent: {
        display: 'flex',
        flexDirection: 'column',
    },
    TableCell: {
        color: '#0088FE',
        fontFamily: "'Segoe UI Variable Static Display 700', sans-serif",
        fontWeight: 'bold',
        fontSize: '17px',
    },
    loadingContainer: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        marginTop: '20px'
    },
    filterSection: {
        marginBottom: theme.spacing(2),
    },
    filterHeader: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: theme.spacing(2),
    },
    filterToggleBtn: {
        borderRadius: '20px',
        textTransform: 'none',
        fontWeight: 'bold',
    },
    filterActions: {
        display: 'flex',
        gap: theme.spacing(1),
    },
    filterBtn: {
        borderRadius: '5px',
        textTransform: 'none',
        fontWeight: 'bold',
        minWidth: '100px',
    },
    downloadBtn: {
        borderRadius: '5px',
        textTransform: 'none',
        fontWeight: 'bold',
        backgroundColor: '#4CAF50',
        color: 'white',
        '&:hover': {
            backgroundColor: '#45a049',
        },
    },
    filterPanel: {
        padding: theme.spacing(2),
        backgroundColor: '#fff',
        borderRadius: '10px',
        marginBottom: theme.spacing(2),
    },
    dataSection: {
        marginBottom: theme.spacing(3),
        padding: theme.spacing(1, 2),
    },
    tableSection: {
        marginTop: theme.spacing(2),
    },
}));

export default useStyles;
